import React, { useEffect, useContext, useState, useReducer, Reducer, Fragment } from 'react';
import { Grid, TextField, Button, Typography, ButtonGroup } from '@material-ui/core';
import { IEmail } from '../../application/models';

import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';

interface IContactEmailProps {
    currentemails: Array<IEmail>,
    updateEmails: (emails: Array<IEmail>) => void
}

interface IContactEmailState {
    newlabel: string;
    newemail: string;
    emails: Array<IEmail>;
}

interface IViewEmailProps {
    email: IEmail;
    deleteEmail: (email: IEmail) => void;
    changeEmail: (oldemail: IEmail, newemail: IEmail) => void;
}

interface IViewEmailState {
    editMode: boolean;
}

interface IEditEmailProps {
    emailVars: IEmail;
    commitEdit: (newEmail: IEmail) => void;
    cancelEdit: () => void;
}


export const EditEmail: React.FC<IEditEmailProps> = (props, context) => {
    let [emailState, setEmailState] = useState<IEmail>({ ...props.emailVars });
    return (
        <Grid container xs={12}>
            <Grid item container xs={12} sm={10}>
                <Grid item xs={12} md={3}>
                    <TextField fullWidth value={emailState.label} variant='outlined' label='Label' size='small' onChange={(e) => { setEmailState({ ...emailState, label: e.target.value }); }} />
                </Grid>
                <Grid item xs={12} md={9}>
                    <TextField fullWidth value={emailState.email} variant='outlined' label='Email' size='small' onChange={(e) => { setEmailState({ ...emailState, email: e.target.value }); }} />
                </Grid>
            </Grid>
            <Grid item xs={12} md={2}>
                <ButtonGroup fullWidth><Button variant='outlined' onClick={() => { props.commitEdit(emailState); }}><SaveIcon /></Button><Button variant='outlined' onClick={props.cancelEdit}><CancelIcon /></Button></ButtonGroup>
            </Grid>
        </Grid>
    );
}

export const ViewEmail: React.FC<IViewEmailProps> = (props, context) => {
    let e: IEmail = props.email;
    let [emailState, setEmailState] = useState<IViewEmailState>({ editMode: false });

    const cancelEdit: () => void = () => {
        setEmailState({ ...emailState, editMode: false });
    }

    if (emailState.editMode == false) {
        return (
            <Grid container>
                <Grid item xs={12} md={3}><Typography align="left">{e.label}</Typography></Grid>
                <Grid item xs={12} md={7}><Typography align="left">{e.email}</Typography></Grid>
                <Grid item xs={12} md={2}><ButtonGroup fullWidth><Button onClick={() => { setEmailState({ ...emailState, editMode: true }); }}><EditIcon /></Button><Button><DeleteIcon onClick={() => { props.deleteEmail(e); }} /></Button></ButtonGroup></Grid>
            </Grid>
        );
    }
    else {
        return <EditEmail emailVars={e} commitEdit={(n) => { props.changeEmail(e, n); setEmailState({ ...emailState, editMode: false }); }} cancelEdit={cancelEdit} />
    }
}

export const EmailEditor: React.FC<IContactEmailProps> = (props, context) => {
    let [state, setState] = useState<IContactEmailState>({ newlabel: "", newemail: "", emails: props.currentemails });

    useEffect(() => {
        setState({ ...state, emails: props.currentemails });
    }, [props.currentemails]);

    const addEmail: () => void = () => {
        let newItem: IEmail = {
            id: "",
            type: "other",
            label: state.newlabel,
            email: state.newemail
        }
        props.updateEmails([...state.emails, newItem]);
        setState({ ...state, newlabel: "", newemail: ""});
    }

    const changeLabel: (event: any) => void = (e) => {
        setState({ ...state, newlabel: e.target.value });
    }

    const updateEmail: (event: any) => void = (e) => {
        setState({ ...state, newemail: e.target.value });
    }

    const deleteEmail: (e: IEmail) => void = (e) => {
        let ix: number = state.emails.indexOf(e);
        if (ix != -1) {
            let emails: Array<IEmail> = state.emails.filter((em) => { return em != e; });
            props.updateEmails(emails);
            //setState({ ...state, emails: emails });
        }
    }

    const changeEmail: (oldEmail: IEmail, newEmail: IEmail) => void = (o, n) => {
        let emails = [...state.emails];
        let ix: number = emails.indexOf(o);
        emails[ix] = n;
        props.updateEmails(emails);
        //setState({ ...state, emails: emails });
    }

    return (
        <Fragment>
            <Grid container alignItems='center' spacing={1}>
                <Grid item xs={12} md={3}>
                    <TextField fullWidth value={state.newlabel} variant='outlined' label='Label' size='small' onChange={changeLabel} />
                </Grid>
                <Grid item xs={12} md={7}>
                    <TextField fullWidth value={state.newemail} variant='outlined' label='Email Address' size='small' onChange={updateEmail} />
                </Grid>
                <Grid item xs={12} md={2}>
                    <ButtonGroup fullWidth><Button variant='outlined' onClick={addEmail}><AddIcon /></Button></ButtonGroup>
                </Grid>
            </Grid>
            <Grid container alignItems="center" spacing={1}>
                {state.emails.map((e, i) => {
                    return (
                        <ViewEmail email={e} deleteEmail={deleteEmail} changeEmail={changeEmail} key={'emvw' + i.toString()} />
                    );
                })}
            </Grid>
        </Fragment>
        );
}